import { Link } from 'react-router-dom';

export default function StatsSection() {
  const stats = [
    { value: '1,280,000+', label: '累计读者' },
    { value: '586', label: '原创文章' },
    { value: '32', label: '认证教练' },
    { value: '6年', label: '深耕健身' },
  ];

  return (
    <section className="py-14 md:py-20 bg-primary-600">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-3xl md:text-4xl font-bold font-heading text-background-50 tracking-wide">
                {stat.value}
              </div>
              <div className="mt-1.5 text-sm text-background-50/70">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function CTASection() {
  return (
    <section className="relative py-14 md:py-24 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Motivational%20fitness%20scene%20with%20athletic%20man%20silhouette%20at%20sunrise%2C%20warm%20golden%20light%2C%20inspirational%20atmosphere%2C%20abstract%20artistic%20style%2C%20soft%20gradients%2C%20cinematic%20mood&width=1600&height=600&seq=cta-section-bg&orientation=landscape')`,
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/60 via-foreground-950/50 to-foreground-950/70"></div>
      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-4xl font-bold font-heading text-background-50 tracking-wide">
          准备好开始你的猛男蜕变之旅了吗？
        </h2>
        <p className="mt-4 text-base md:text-lg text-background-50/80 max-w-xl mx-auto">
          加入超过128万读者的猛男诞生记，从今天开始，科学训练、合理饮食、突破自我
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/training-plan"
            className="px-8 py-3 bg-primary-500 hover:bg-primary-400 text-background-50 font-semibold rounded-md transition-colors whitespace-nowrap cursor-pointer"
          >
            立即开始训练
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 border-2 border-background-50/40 hover:border-background-50/80 text-background-50 font-semibold rounded-md transition-colors whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}